var _rect, _path, _path2, _path3, _ellipse, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinButton2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 60,
    viewBox: "0 0 214 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_2527_9495)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2527_9495)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 210,
    height: 56,
    rx: 28,
    fill: "url(#paint0_radial_2527_9495)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.182 44.9459H56.7639C56.7639 41.5359 55.4886 38.5545 52.94 36.0059C50.3915 33.4573 47.4122 32.182 44 32.182V31.7639C47.4122 31.7639 50.3915 30.4886 52.94 27.9337C55.4886 25.3788 56.7639 22.3995 56.7639 19H57.182C57.182 22.4101 58.4574 25.3915 61.0059 27.94C63.5545 30.4886 66.5338 31.7639 69.9459 31.7639V32.182C66.5359 32.182 63.5545 33.4573 61.0059 36.0059C58.4574 38.5545 57.182 41.5338 57.182 44.9459Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8778 30.6757H75.6897C75.6897 29.1412 75.1158 27.7995 73.9689 26.6527C72.8221 25.5058 71.4814 24.9319 69.9459 24.9319V24.7438C71.4814 24.7438 72.8221 24.1699 73.9689 23.0202C75.1158 21.8705 75.6897 20.5298 75.6897 19H75.8778C75.8778 20.5345 76.4517 21.8762 77.5986 23.023C78.7454 24.1699 80.0861 24.7438 81.6216 24.7438V24.9319C80.0871 24.9319 78.7454 25.5058 77.5986 26.6527C76.4517 27.7995 75.8778 29.1402 75.8778 30.6757Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 32.98V32.26H88.3V32.98C88.3 34.4 89.08 35.42 90.68 35.42C92.32 35.42 93.04 34.42 93.04 32.92V22.54H95V33C95 35.6 93.26 37.24 90.68 37.24C87.92 37.24 86.4 35.48 86.4 32.98ZM97.1059 32.1C97.1059 29.08 99.2659 26.96 102.206 26.96C105.126 26.96 107.286 29.08 107.286 32.1C107.286 35.12 105.126 37.24 102.206 37.24C99.2659 37.24 97.1059 35.12 97.1059 32.1ZM99.0059 32.1C99.0059 34.14 100.306 35.56 102.206 35.56C104.086 35.56 105.406 34.14 105.406 32.1C105.406 30.06 104.086 28.64 102.206 28.64C100.306 28.64 99.0059 30.06 99.0059 32.1ZM110.087 24.9C109.407 24.9 108.847 24.34 108.847 23.66C108.847 22.96 109.407 22.42 110.087 22.42C110.767 22.42 111.327 22.96 111.327 23.66C111.327 24.34 110.767 24.9 110.087 24.9ZM109.167 37V27.22H111.047V37H109.167ZM115.456 37H113.576V27.22H115.276L115.476 28.72C116.096 27.6 117.336 26.94 118.716 26.94C121.296 26.94 122.476 28.52 122.476 31.02V37H120.596V31.44C120.596 29.46 119.676 28.66 118.236 28.66C116.476 28.66 115.456 29.92 115.456 31.82V37ZM132.429 37H130.469V22.54H132.429L139.829 33.72V22.54H141.789V37H139.829L132.429 25.82V37ZM143.997 32.1C143.997 29.08 146.157 26.96 149.097 26.96C152.017 26.96 154.177 29.08 154.177 32.1C154.177 35.12 152.017 37.24 149.097 37.24C146.157 37.24 143.997 35.12 143.997 32.1ZM145.897 32.1C145.897 34.14 147.197 35.56 149.097 35.56C150.977 35.56 152.297 34.14 152.297 32.1C152.297 30.06 150.977 28.64 149.097 28.64C147.197 28.64 145.897 30.06 145.897 32.1ZM157.708 37L154.508 27.22H156.448L158.068 32.3C158.288 33.02 158.488 33.76 158.668 34.62C158.828 33.76 159.088 32.94 159.308 32.3L160.948 27.22H162.868L164.488 32.3C164.648 32.78 164.968 33.92 165.128 34.62C165.288 33.84 165.468 33.16 165.748 32.3L167.388 27.22H169.348L166.008 37H164.228L162.528 31.76C162.208 30.78 162.008 30.02 161.908 29.48C161.808 29.96 161.628 30.6 161.268 31.78L159.568 37H157.708Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter1_f_2527_9495)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.735,
    cy: 49.3516,
    rx: 55.1351,
    ry: 4.54054,
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.35135,
    y: 1.35135,
    width: 211.297,
    height: 57.2973,
    rx: 28.6486,
    stroke: "url(#paint1_linear_2527_9495)",
    strokeOpacity: 0.08,
    strokeWidth: 1.2973
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_2527_9495",
    x: 0.702759,
    y: -30.4325,
    width: 212.595,
    height: 100.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 20.7568,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_2527_9495"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.3784
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5676
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_2527_9495"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -31.1351
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20.7568
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2527_9495",
    result: "effect2_innerShadow_2527_9495"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.78378
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2527_9495",
    result: "effect3_innerShadow_2527_9495"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2527_9495",
    x: 35.7347,
    y: 27.9462,
    width: 144,
    height: 42.8108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.43243,
    result: "effect1_foregroundBlur_2527_9495"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2527_9495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107 30) scale(105 28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A083F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27009D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2527_9495",
    x1: 2,
    y1: 30,
    x2: 212,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250099"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2527_9495"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 210,
    height: 56,
    rx: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinButton2);
export default __webpack_public_path__ + "static/media/joinButton2.b949017943168f0d42a145f0f55139d5.svg";
export { ForwardRef as ReactComponent };